module.exports = __webpack_public_path__ + "img/dymocks.68a48ead.png";